import React from 'react';
import { Badge } from 'react-bootstrap';

interface AutodeclaracaoRacialBadgeProps {
    autodeclaracaoRacial?: string;
    className?: string;
}

const AutodeclaracaoRacialBadge: React.FC<AutodeclaracaoRacialBadgeProps> = ({ 
    autodeclaracaoRacial, 
    className = '' 
}) => {
    if (!autodeclaracaoRacial || autodeclaracaoRacial === 'NAO_DECLARADO') {
        return null;
    }

    const formatarAutodeclaracao = (valor: string): string => {
        const mapa: { [key: string]: string } = {
            'PARDO': 'Pardo',
            'PRETO': 'Preto',
            'INDIGENA': 'Indígena',
            'BRANCO': 'Branco',
            'AMARELO': 'Amarelo'
        };
        return `Autodeclarado: ${mapa[valor] || valor}`;
    };

    return (
        <Badge 
            bg="light" 
            text="dark" 
            className={`ms-2 ${className}`}
            style={{ 
                fontSize: '0.75rem', 
                fontWeight: 'normal',
                opacity: 0.7
            }}
        >
            {formatarAutodeclaracao(autodeclaracaoRacial)}
        </Badge>
    );
};

export default AutodeclaracaoRacialBadge;
